var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.123,
    height: 68.518,
    viewBox: "0 0 200.123 68.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo13",
    transform: "translate(-733.802 -4946.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11156",
    "data-name": "Group 11156",
    transform: "translate(-118.142 -115.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M768.071-84.647v-4.395h17.451l18.037,46.8c.245-.581.391-.886.5-1.2q7.855-22.2,15.673-44.4a1.641,1.641,0,0,1,1.894-1.313c5.359.053,10.717.024,16.076.024h1.274v68.17H827.066v-50.46l-.322-.058q-.832,2.16-1.663,4.323Q816.444-44.533,807.831-21.9a1.352,1.352,0,0,1-1.539,1.044q-3.654-.079-7.306,0a1.222,1.222,0,0,1-1.37-.95q-9.569-24.974-19.182-49.932c-.818-2.129-1.618-4.263-2.46-6.382a9.921,9.921,0,0,0-7.9-6.533",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M754.508-45.275c1.049,2.124,2.038,4.135,3.034,6.142,1.38,2.779,2.683,5.6,4.174,8.319a9.737,9.737,0,0,0,7.359,5.4v4.443a7.009,7.009,0,0,1-.854.1c-3.3,0-6.6-.029-9.891,0a7.661,7.661,0,0,1-7.4-4.351c-2-3.847-3.948-7.726-5.9-11.6q-4.309-8.568-8.588-17.156c-.149-.3-.281-.61-.49-1.066.478-.031.867-.074,1.255-.077,3.372-.024,6.747.034,10.114-.077a10.335,10.335,0,0,0,10.241-10.272c.2-6.223-3.754-11.079-9.636-11.607-2.715-.242-5.46-.178-8.192-.192q-6.966-.04-13.937.01a1.379,1.379,0,0,1-1.459-.9C722.7-81.518,721-84.85,719.327-88.2c-.13-.259-.221-.538-.384-.941h1.186c8.842,0,17.684-.053,26.526.022a24.561,24.561,0,0,1,13.239,3.677c6.9,4.4,10.205,10.827,10.366,18.922a22.189,22.189,0,0,1-3.473,13.023,19.286,19.286,0,0,1-10.5,7.654c-.528.173-1.061.336-1.781.564",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M884.753-45.672a12.045,12.045,0,0,0-.746-2.386,1.959,1.959,0,0,0-3.427-.12,5,5,0,0,0-.055,5.009,1.945,1.945,0,0,0,3.425-.079,12.656,12.656,0,0,0,.8-2.424m-13.937,3.283c0-1.644.062-3.137-.019-4.623a2.176,2.176,0,0,0-1.9-2.179,2.211,2.211,0,0,0-2.41,1.6,8.705,8.705,0,0,0-.214,3.063,2.381,2.381,0,0,0,2.268,2.126c.7.074,1.409.012,2.271.012m7.579-.079a20.753,20.753,0,0,1-.386-4.037c.274-2.885,2.285-4.479,4.92-4.176,2.307.264,3.9,2.4,3.694,5.081a7.675,7.675,0,0,1-.581,2.489,3.866,3.866,0,0,1-3.807,2.453c-2.7-.01-5.391,0-8.088,0h-1.174c-.951,3.175-1.8,3.991-4.433,4.2-.086-.478-.175-.97-.276-1.524,1.253-.41,2.549-.77,2.318-2.679-.538,0-1.078,0-1.618,0a4.4,4.4,0,0,1-4.762-4.431,4.964,4.964,0,0,1,3.495-5.467c2.861-.758,5.033.876,5.074,3.838.022,1.382,0,2.765,0,4.253Z",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M896.2-41.735a14.074,14.074,0,0,0,.9,2.53,1.91,1.91,0,0,0,3.334.017,5.11,5.11,0,0,0,.094-5.11,1.919,1.919,0,0,0-3.449.012,14.212,14.212,0,0,0-.878,2.551m15.353-8.9h2.155c-.113,2.525-.079,5.028-.382,7.491-.206,1.7-1.474,2.479-3.221,2.484-1.985.007-3.97.031-5.955-.012a1.142,1.142,0,0,0-1.351.946,4.217,4.217,0,0,1-4.193,3.1,4.08,4.08,0,0,1-3.891-3.3c-.185-.672-.545-.953-1.09-.768a8.314,8.314,0,0,0-2.307,1.13,3.467,3.467,0,0,0-.8,1.45c-.667,1.586-.655,1.594-2.657,1.4a38.569,38.569,0,0,1,1.956-3.924,3.754,3.754,0,0,1,3.545-1.783c.852.062,1.159-.223,1.344-1.049a4.082,4.082,0,0,1,4.006-3.43,4,4,0,0,1,4.138,2.95c.156.49.257,1,.4,1.579,2.263,0,4.507.043,6.747-.019.946-.029,1.515-.955,1.546-2.275.024-.972.007-1.946.007-2.921v-3.043",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M895.681-27.981c-.132,2.376-.259,4.668-.391,7.023H893.5c.173-3.523.346-7.015.516-10.529,1.145-.281,1.968-.23,2.53.972.614,1.31,1.45,2.518,2.335,4.018.794-1.373,1.555-2.549,2.174-3.8.538-1.08,1.21-1.675,2.638-1.162.168,3.408.341,6.929.516,10.51h-1.858q-.194-3.471-.389-6.96l-.3-.086c-.576.974-1.147,1.949-1.723,2.921-.89,1.507-1.32,1.514-2.213.05q-.846-1.39-1.714-2.765c-.031-.05-.11-.07-.329-.194",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M859.661-53.12c.73-.1,1.342-.187,2.078-.29,0,1.121.014,2.124,0,3.127-.055,3.178.014,6.365-.228,9.528-.211,2.729-2.1,4.179-4.9,4.179s-4.541-1.438-4.9-4.2c-.194-1.51-.187-3.043-.276-4.663h2.2c0,1.394-.055,2.8.017,4.207a2.976,2.976,0,0,0,2.059,2.909c2.078.6,3.819-.682,3.9-3.075.106-3.139.046-6.288.055-9.432,0-.742,0-1.483,0-2.292",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M889.174-20.915h-1.855c0-1.37.007-2.739,0-4.1-.01-1.418-.413-1.985-1.394-1.985-1.039,0-1.723.775-1.745,2.045-.022,1.3,0,2.607,0,3.989H882.3c0-1.38.007-2.755,0-4.128-.007-1.308-.425-1.879-1.378-1.906a1.8,1.8,0,0,0-1.829,1.874c-.055,1.2-.017,2.4-.024,3.593,0,.18-.036.36-.06.59h-1.584v-7.536c.634.11,1.222.216,1.81.319-.019.134-.041.269-.06.4,1.419-.979,2.808-1.241,4.21-.017.12.1.55-.043.766-.182a3.4,3.4,0,0,1,3.61-.266c1.234.648,1.435,1.812,1.421,3.07-.019,1.378,0,2.758,0,4.241",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M853.471-26.811c1.133-.082,2.362.449,3.024-.73a2.045,2.045,0,0,0-.115-1.824c-.708-.955-1.829-.718-2.909-.6Zm-.06,1.733v4.128h-1.819V-31.479a42.092,42.092,0,0,1,4.769.043,2.725,2.725,0,0,1,2.359,2.4,3.243,3.243,0,0,1-1.03,3.154c-.187.175-.4.322-.686.547.778,1.44,1.551,2.871,2.335,4.327-2.033.307-2.033.307-2.9-1.378-.29-.564-.566-1.138-.862-1.7-.6-1.138-.6-1.135-2.165-.989",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M865.675-25.517a1.711,1.711,0,0,0-1.882-1.627,1.693,1.693,0,0,0-1.85,1.627Zm1.867,1.438h-5.527c.2,2.033,2.062,2.465,4.5,1.114l.852.926c-.869,1.538-3.977,1.757-5.443.9a4.3,4.3,0,0,1-1.622-5.136,3.815,3.815,0,0,1,4.354-2.354c1.807.293,2.88,1.9,2.892,4.553",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M870.3-25.554h3.787a1.674,1.674,0,0,0-1.706-1.6,1.892,1.892,0,0,0-2.081,1.6m4.685,2.571.8.926c-.8,1.558-4.071,1.793-5.535.857a4.351,4.351,0,0,1-1.428-5.3,3.838,3.838,0,0,1,4.5-2.078c1.778.468,2.782,2.177,2.506,4.464H870.4c.307,2.074,2.057,2.479,4.587,1.128",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M910.323-24.475a12.708,12.708,0,0,0-2.436.341A1.371,1.371,0,0,0,907.268-23c.017.3.511.732.874.838,1.346.4,2.34-.542,2.182-2.316m-3.783-2.138c-.245-.382-.461-.718-.674-1.044a4.525,4.525,0,0,1,5.05-.5,2.83,2.83,0,0,1,1.166,1.759c.156,1.774.055,3.571.055,5.616-.641-.149-1.164-.293-1.7-.384a1.688,1.688,0,0,0-.65.072,10,10,0,0,1-1.822.425,2.335,2.335,0,0,1-2.486-1.961,2.4,2.4,0,0,1,1.663-2.82,22.213,22.213,0,0,1,3.185-.4c-.2-1.464-1.3-1.711-3.79-.761",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M914.825-36.515c-.07-.446-.139-.91-.23-1.51,2.518-.228,2.585-2.035,2.568-3.917-.022-2.2,0-4.4,0-6.684H919c0,2.967.187,5.887-.06,8.772-.2,2.347-1.586,3.279-4.114,3.339",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M913.87-20.931h1.673V-31.544H913.87Z",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M917.446-20.941h1.56V-31.551h-1.56Z",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M911.849-37.377c-.4.264-.775.677-1.212.758-.727.134-1.118-.358-1.092-1.073s.451-1.193,1.15-1.044c.432.091.78.562,1.167.862,0,.166-.007.331-.012.5",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M906.942-36.633a2.871,2.871,0,0,1-.571-1.03.858.858,0,0,1,1.061-1.058,1.6,1.6,0,0,1,1,1.063c.1.614-.3,1.145-1.491,1.025",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient13);
export default __webpack_public_path__ + "static/media/client13.5040e877fc318e9ff8ce4d944d610c09.svg";
export { ForwardRef as ReactComponent };